import React from 'react';
import { GrAd } from "react-icons/gr";
import LogoStyles from '../styles/LogoStyles';
import logo from './fatwaa.png';


function Logo() {
  return (
    <LogoStyles to="/">
      <img src={logo} alt="Fatwa logo" style={{ width: '70px', height: 'auto' }} />
    </LogoStyles>
  );
}

export default Logo;
